import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_LIST_REDEMPTION = gql`
  query GetList($where: Map, $sort: Map, $limit: Int, $offset: Int) {
    GetRedemptionList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on Redemptions {
        data {
          id
          province_code
          province {
            ... on Province {
              id
              name
              code
              wil
            }
          }
          district_code
          district {
            ... on District {
              id
              type
              name
              code
            }
          }
          ad_integration_id
          redemeed_at
          qty
          store_name
          total_sales
          deleted_at
          updated_at
          created_at
        }
      }
    }
  }
`;

export const GET_LIST_REDEMPTION_DOWNLOAD = gql`
  query GetList($where: Map, $sort: Map, $limit: Int, $offset: Int) {
    GetRedemptionList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on Redemptions {
        data {
          id
          province_code
          province {
            ... on Province {
              name
              code
            }
          }
          district_code
          district {
            ... on District {
              name
              code
            }
          }
          ad_integration_id
          redemeed_at
          qty
          store_name
          total_sales
          deleted_at
        }
      }
    }
  }
`;

export const GET_REDEMPTION_SUMMARY = gql`
  query GetSummary($where: Map, $sort: Map) {
    list: GetRedemptionSummary(
      pagination: { offset: 0, limit: 10, where: $where, sort: $sort }
    ) {
      total_sales
      total_qty
    }
  }
`;
